export default {
  heroHeadingTextTransform: 'uppercase',
  textCartConfirmationColor: Styles.color.grey.one,
  cartConfirmationItemBorder: '',
  pickupInstructionsColor: Styles.color.grey.one,
};
